import { DiamondIcon } from '@/components/svg/diamond-icon/diamond-icon'
import cx from 'classnames'
import s from './featured-badge.module.scss'

type Props = {
  className?: string
}

export const FeaturedBadge = ({ className }: Props) => {
  return (
    <span className={cx(s.featuredBadge, className)}>
      <DiamondIcon
        iconColor="#fff"
        svgProps={{
          width: 12,
          height: 12,
          'aria-hidden': true,
          focusable: false,
        }}
      />
      Featured
    </span>
  )
}
